import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatRadioChange } from '@angular/material';

@Component({
  selector: 'app-set-field',
  templateUrl: './set-field.component.html',
  styleUrls: ['./set-field.component.scss']
})
export class SetFieldComponent implements OnInit {

  @Output()
  setAval: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  radioChange(event: MatRadioChange) {
    this.setAval.emit(event.value);
}

}
